export default {
  SET_GIFTCARD_IMAGE(state, imgUrl, giftcardId) {
    console.log("in mutation");
    let giftcard = state.giftcard.find(function(element) {
      return element == giftcardId;
    });
    console.log(giftcard);
    let giftcardIndex = state.giftcard.indexof(giftcard);
    console.log(giftcardIndex);

    state.giftcards[giftcardIndex].image = imgUrl;
  },

  ADD_GIFTCARD(state, newGiftcard){
    state.giftcards.push(newGiftcard);
  },

  SAVE_MERCHANT(state, merchantDetails){
    console.log(merchantDetails);
    
    state.merchant = merchantDetails;
  },

  EDIT_GIFTCARD(state, obj){
    let index;
    for (let i=0; i<state.giftcards.length; i++){
      if(JSON.stringify(state.giftcards[i]) == JSON.stringify(obj.initialGiftcard)){
        index = i;
        state.giftcards[i] = obj.editedGiftcard;
        break;
      }
    }        
    // let index = state.giftcards.indexOf(obj.initialGiftcard);
    console.log(obj.initialGiftcard);
    console.log(index);
    console.log(obj.editedGiftcard);            
  },

  DELETE_GIFTCARD(state, obj){
    for (let i=0; i<state.giftcards.length; i++){
      if(state.giftcards[i] == obj){
        state.giftcards.splice(i, 1);
        break;
      }
    }
  }
};
